import React, { Component } from "react";
import ReactPlayer from "react-player";

let randomFreq;
class SingleSound extends Component {
  state = {
    playing: false,
    pl: false,
    volume: this.props.vol,
    freq: 6000,
    className: "snd",
    sliderClass: "sliderhide"
  };

  clicked = () => {
    if (this.state.pl === true) {
      this.setState({
        pl: false,
        playing: false,
        className: "snd",
        sliderClass: "sliderhide"
      });
    } else {
      this.setState({
        pl: true,
        playing: true,
        className: "nan",
        sliderClass: "slider"
      });
    }
  };

  /* volume slider */
  onSliderChange = () => {
    this.setState({
      volume: parseFloat(document.getElementById(this.props.id).value)
    });
  };

  /* frequency slider */
  onFreqChange = () => {
    this.setState({
      freq: parseInt(12000 - document.getElementById(this.props.id + "2").value)
    });
  };

  /* control the delay of replaying the sound */
  onEnd = () => {
    /* randomize the delay a bit */
    randomFreq = Math.floor(
      Math.random() * (this.state.freq - 1) + 1
    );

    if (this.state.pl === true) {
      this.setState({
        playing: false
      });
      /* play the sound with a timeout of combined slider value and random value */
      setTimeout(() => {
        if (this.state.pl === true) {
          this.setState({
            playing: true
          });
        }
      }, this.state.freq + randomFreq);
    }
  };

  render() {
    //voll = this.props.vol;
    /*setTimeout(() => {
      if (this.props.vol !== this.state.volume) {
        this.setState({
          volume: this.props.vol
        });
        document.getElementById(this.props.id).defaultValue = this.props.vol;
      }

    }, 100);*/
    
    return (
      <div className="sound-container">
        <img
          src={this.props.picture}
          onClick={this.clicked}
          className={this.state.className}
          alt="kiuas"
          id={this.props.id + this.state.className}
        />
        <div>
          <input
            type="range"
            className={this.state.sliderClass}
            id={this.props.id}
            step="0.05"
            min="0"
            max="1"
            onChange={this.onSliderChange}
            defaultValue={this.state.volume}
          />
        </div>
        {!this.props.loop ? (
          <div>
            <input
              type="range"
              className={this.state.sliderClass}
              id={this.props.id + "2"}
              step="500"
              min="0"
              max="12000"
              defaultValue="6000"
              onChange={this.onFreqChange}
            />
          </div>
        ) : null}
        <ReactPlayer
          id="player"
          url={this.props.sound}
          loop={this.props.loop}
          playing={this.state.playing}
          volume={this.state.volume}
          onEnded={this.onEnd}
          height="0"
        />
      </div>
    );
  }
}

export default SingleSound;
